<template>
  <section class="relative max-w-screen-xl mx-auto px-4 lg:mt-48 mt-10">
    <div
      class="absolute max-lg:hidden top-0 left-[13%] p-[0.2px] bg-[image:var(--border-bg-achievements)] w-[1px] h-[60rem]"
    />
    <div
      class="absolute max-lg:hidden top-0 left-[35%] p-[0.2px] bg-[image:var(--border-bg-achievements)] w-[1px] h-[60rem]"
    />
    <div
      class="absolute max-lg:hidden left-1/2 top-0 transform -translate-x-1/2 p-[0.2px] bg-[image:var(--border-bg-achievements)] w-[1px] h-[60rem]"
    />
    <div
      class="absolute max-lg:hidden top-0 right-[31%] p-[0.2px] bg-[image:var(--border-bg-achievements)] w-[1px] h-[60rem]"
    />
    <div
      class="absolute max-lg:hidden top-0 right-[13%] p-[0.2px] bg-[image:var(--border-bg-achievements)] w-[1px] h-[60rem]"
    />

    <h2 class="max-w-screen-xl mx-auto max-md:hidden">
      <span
        class="block xl:text-9xl md:text-6xl max-lg:text-4xl mb-3 translate-x-[-100%] animate-slide-in text-center"
      >
        Awards and
      </span>
      <span
        class="block xl:text-9xl md:text-6xl max-lg:text-4xl mb-6 md:mb-8 translate-x-[0%] animate-slide-out text-center"
      >
        <WrGradientText text="Recognition" append-class="pb-4 pt-0" />
      </span>
    </h2>
    <h2 class="max-w-screen-xl mx-auto hidden max-md:block">
      <span
        class="block xl:text-9xl md:text-6xl max-lg:text-4xl mb-3 text-center"
      >
        Awards and
      </span>
      <span
        class="block xl:text-9xl md:text-6xl max-lg:text-4xl mb-6 md:mb-8 text-center"
      >
        <WrGradientText text="Recognition" append-class="pb-4 pt-0" />
      </span>
    </h2>

    <div
      class="lg:relative w-full lg:h-[400px] flex max-lg:gap-5 max-lg:overflow-x-auto items-center lg:justify-center text-white lg:mb-80 mb-20 no-scrollbar"
    >
      <div
        class="lg:absolute lg:top-[100px] h-full max-h-[317px] min-h-[317px] max-w-[317px] min-w-[250px] w-full bg-[url(/images/cssWineBgImg.webp)] bg-no-repeat bg-cover max-sm:p-8 p-14 lg:opacity-0 xl:animate-[spread-card-1_0.8s_ease-out_forwards] lg:animate-[spread-card-xl-1_0.8s_ease-out_forwards] shadow-[0px_4px_35px_0px_#00000040] dark:shadow-none"
      >
        <div class="flex flex-col justify-start items-start">
          <NuxtImg
            src="/images/cssWineImg.webp"
            width="285"
            height="35"
            class="block"
            loading="lazy"
            alt="CSS Wine Image"
            format="webp"
          />
          <p class="text-xl mt-14">Awarding and</p>
          <p class="text-xl">showcasing</p>
          <p class="text-xl mt-6">INDIA</p>
        </div>
      </div>

      <div
        class="lg:absolute lg:top-20 h-full max-h-[317px] min-h-[317px] max-w-[317px] min-w-[250px] w-full bg-[url(/images/cssGroupBgImg.webp)] bg-no-repeat bg-cover max-sm:p-8 p-14 lg:opacity-0 xl:animate-[spread-card-2_0.8s_ease-out_forwards] lg:animate-[spread-card-xl-2_0.8s_ease-out_forwards] shadow-[0px_4px_35px_0px_#00000040] dark:shadow-none"
      >
        <div class="flex flex-col justify-start items-start">
          <NuxtImg
            src="/images/cssGroupImg.webp"
            width="110"
            height="64"
            class="block"
            loading="lazy"
            alt="CSS Group Image"
            format="webp"
          />
          <p class="text-xl mt-6">CSS Gallery</p>
          <p class="text-xl">Pro Award</p>
          <p class="text-xl mt-6">INDIA</p>
        </div>
      </div>

      <div
        class="lg:absolute lg:top-[170px] h-full max-h-[317px] min-h-[317px] max-w-[317px] min-w-[250px] w-full bg-[url(/images/cssReelBgImg.webp)] bg-no-repeat bg-cover max-sm:p-8 p-14 lg:opacity-0 xl:animate-[spread-card-3_0.8s_ease-out_forwards] lg:animate-[spread-card-xl-3_0.8s_ease-out_forwards] shadow-[0px_4px_35px_0px_#00000040] dark:shadow-none"
      >
        <div class="flex flex-col justify-start items-start">
          <NuxtImg
            src="/images/cssReelImg.webp"
            width="156"
            height="37"
            class="block"
            loading="lazy"
            alt="CSS Reel Image"
            format="webp"
          />
          <p class="text-xl mt-12">CSS Reel</p>
          <p class="text-xl">Award</p>
          <p class="text-xl mt-6">INDIA</p>
        </div>
      </div>

      <div
        class="lg:absolute lg:top-24 h-full max-h-[317px] max-w-[317px] min-h-[317px] min-w-[250px] w-full bg-[url(/images/parivartamBgImg.webp)] bg-no-repeat bg-cover max-sm:p-8 p-14 lg:opacity-0 xl:animate-[spread-card-4_0.8s_ease-out_forwards] lg:animate-[spread-card-xl-4_0.8s_ease-out_forwards] shadow-[0px_4px_35px_0px_#00000040] dark:shadow-none"
      >
        <div class="flex flex-col justify-start items-start">
          <NuxtImg
            src="/images/parivartanAwardImg.webp"
            width="67"
            height="67"
            class="block"
            loading="lazy"
            alt="Parivartan Award Image"
            format="webp"
          />
          <p class="text-xl mt-5">Parivartan</p>
          <p class="text-xl">Awards</p>
          <p class="text-xl mt-6">INDIA</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup></script>

<style lang="scss" scoped></style>
